import * as ActionCable from '@rails/actioncable';

function resolveCableUrl() {
  const configuredUrl = document
    ?.querySelector('meta[name="school-bridge-cable-url"]')
    ?.getAttribute("content")
    ?.trim();

  if (configuredUrl) {
    return configuredUrl;
  }

  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  return `${protocol}://${window.location.host}/cable`;
}

window.App = window.App || {};
window.App.cable = ActionCable.createConsumer(resolveCableUrl());
